module.exports = __webpack_public_path__ + "static/media/portfolio13.5c05413e.avif";